import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { ToastProvider } from "./contexts/ToastContext";
import "react-toastify/dist/ReactToastify.css";
import Registration from "./components/Auth/Registration";
import "./App.css";
import Login from "./components/Auth/Login";
import Dashboard from "./components/Dashboard/Dashboard";
import Settings from "./components/Setting/Settings";
import PrivateRoute from "./components/PrivateRoute";
import Users from "./components/User/Users";
import Premises from "./components/Premise/Premises";
import VerifyEmail from "./components/Auth/VerifyEmail";
import Report from "./components/Report/Report";
import Timing from "./components/Report/Timing/Timing";
import BreakAndViolation from "./components/Report/BreakAndViolation/BreakAndViolation";
import PremiseList from "./components/Premise/PremiseList";
import BreakAndViolationReport from "./components/Report/BreakAndViolation/BreakAndViolationReport";
import ForgotPassword from "./components/Auth/ForgotPassword";
import OtpVerification from "./components/Auth/OtpVerification";
import ChangePassword from "./components/Auth/ChangePassword";
import PremiseAction from "./components/Premise/PremiseAction";
import UserAction from "./components/User/UserAction";
import TimeOffPolicies from "./components/Setting/TimeOffConfiguration/TimeOffPolicies";
import TimeOffConfiguration from "./components/Setting/TimeOffConfiguration/TimeOffConfiguration";
import AddExistingUserAction from "./components/User/AddExistingUserAction";
import Statistics from "./components/User/Statistics/Statistics";
import TimingReport from "./components/Report/Timing/TimingReport";
import LeaveReport from "./components/Report/Leave/LeaveReport";
import Profile from "./components/User/Profile";
import TimePermissionReport from "./components/Report/TimePermission/TimePermissionReport";
import SubscriptionPlanDetails from "./components/Subscription/SubscriptionPlanDetails";
import SubscriptionCheckOut from "./components/Subscription/SubscriptionCheckOut";
import Payments from "./components/Invoice/Payments.js";
import SubscriptionPaymentDetails from "./components/Subscription/SubscriptionPaymentDetails.js";
import SubscriptionSummary from "./components/Invoice/SubscriptionSummary.js";
import WorkShiftTemplate from "./components/WorkShifts/WorkShiftTemplate.js";
import StaffShift from "./components/WorkShifts/StaffShift.js";
import DefineWorkLocation from "./components/WorkLocations/DefineWorkLocation.js";
import AssignLocationToStaff from "./components/WorkLocations/AssignLocationToStaff.js";
import PayrollConnect from "./components/Setting/IntutitPayrollConnect/PayrollConnect.js";
import TimeLogEntry from "./components/Setting/IntutitPayrollConnect/TimeLogEntry/TimeLogEntry.js";
import APISettings from "./components/Setting/APISettings.js";
import AIPage from "./components/AI/AIPage.js";

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // const token = sessionStorage.getItem('authToken');
    const token = localStorage.getItem("authToken");
    // console.log("Token found:", token);
    setIsAuthenticated(!!token);
    // console.log = () => {};
  }, []);

  return (
    <ToastProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Navigate to="/signin" />} />
            <Route path="/registration" element={<Registration />} />
            <Route path="/email/verify/:id/:hash" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/otp-verification" element={<OtpVerification />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/signin" element={<Login />} />
            {/* Payment Gateway Routes  */}

            {/* Payment Gateway Functionality Start  */}

            {/* <Route
              path="/subscription/plan-details"
              element={<SubscriptionPlanDetails />}
            />
            <Route
              path="/subscription/checkout"
              element={<SubscriptionCheckOut />}
            />
            <Route
              path="/subscription/payment-details"
              element={<SubscriptionPaymentDetails />}
            /> */}

            {/* Payment Gateway Functionality End */}

            {/* Dashboard Routes  */}
            <Route
              path="/dashboard"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <Dashboard />
                </PrivateRoute>
              }
            />

            {/* Premises Routes  */}

            <Route
              path="/premises"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <Premises />
                </PrivateRoute>
              }
            />
            <Route
              path="/premise/create"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <PremiseAction />
                </PrivateRoute>
              }
            />
            <Route
              path="/premise/update"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <PremiseAction />
                </PrivateRoute>
              }
            />
            {/* Users Routes  */}
            <Route
              path="/users"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <Users />
                </PrivateRoute>
              }
            />
            <Route
              path="/user/create"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <UserAction />
                </PrivateRoute>
              }
            />
            <Route
              path="/user/update"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <UserAction />
                </PrivateRoute>
              }
            />
            <Route
              path="/user/existing/add"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <AddExistingUserAction />
                </PrivateRoute>
              }
            />
            <Route
              path="/user/statistics"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <Statistics />
                </PrivateRoute>
              }
            />

            {/* WorkShift Routes  */}
            <Route
              path="/workshift/defineshifts"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <WorkShiftTemplate />
                </PrivateRoute>
              }
            />
            <Route
              path="/workshift/staffshifts"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <StaffShift />
                </PrivateRoute>
              }
            />

            {/* WorkLocation Routes  */}
            <Route
              path="/worklocation/definelocation"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <DefineWorkLocation />
                </PrivateRoute>
              }
            />

            <Route
              path="/worklocation/assignlocationtostaff"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <AssignLocationToStaff />
                </PrivateRoute>
              }
            />

            {/* Report Routes  */}
            <Route
              path="/report"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <Report />
                </PrivateRoute>
              }
            />
            <Route
              path="/report/timing"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <Timing />
                </PrivateRoute>
              }
            />

            <Route
              path="/report/break-violation"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <BreakAndViolationReport />
                </PrivateRoute>
              }
            />
            <Route
              path="/report/leave"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <LeaveReport />
                </PrivateRoute>
              }
            />
            <Route
              path="/report/timepermission"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <TimePermissionReport />
                </PrivateRoute>
              }
            />

            {/* Setting Routes  */}
            <Route
              path="/settings"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <Settings />
                </PrivateRoute>
              }
            />
            <Route
              path="/settings/time-off/policy"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <TimeOffPolicies />
                </PrivateRoute>
              }
            />
            <Route
              path="/settings/time-off/policy/create"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <TimeOffConfiguration />
                </PrivateRoute>
              }
            />
            <Route
              path="/settings/time-off/policy/view"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <TimeOffConfiguration />
                </PrivateRoute>
              }
            />

            {/* Payroll Routes  */}
            <Route
              path="/settings/payroll"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <PayrollConnect />
                </PrivateRoute>
              }
            />

                        {/* Payroll Routes  */}
            <Route
              path="/ai"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <AIPage />
                </PrivateRoute>
              }
            />

            {/* API Settings Routes  */}
            <Route
              path="/settings/api"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <APISettings />
                </PrivateRoute>
              }
            />

            <Route
              path="/settings/payroll/addTimeLog"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <TimeLogEntry />
                </PrivateRoute>
              }
            />

            {/* Account Routes  */}
            <Route
              path="/account/profile"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <Profile />
                </PrivateRoute>
              }
            />

            {/* Payment Gateway Routes  */}

            {/* Payment Gateway Functionality Start */}

            {/* <Route
              path="/account/payments"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <Payments />
                </PrivateRoute>
              }
            />
            <Route
              path="/account/subscription"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <SubscriptionSummary />
                </PrivateRoute>
              }
            /> */}

            {/* Payment Gateway Functionality End  */}
          </Routes>
        </div>
      </Router>
    </ToastProvider>
  );
};

export default App;
